const types = {
  LOAD: 'app/history/LOAD',
  LOAD_SUCCESS: 'app/history/LOAD_SUCCESS',
  LOAD_FAIL: 'app/history/LOAD_FAIL',
  RESET: 'app/history/RESET',
};

export default types;
